module.exports = __webpack_public_path__ + "static/media/image-sixth-strip.b5b155dc.svg";